import { signIn } from "next-auth/client";
import Link from "next/link";
import { Button } from "shared/components/atoms/Button";
import { Image } from "shared/components/atoms/Image";
import { PrivacyPolicy } from "shared/components/molecules/PrivacyPolicy";
import { BaseModal } from "shared/components/organisms/modal/BaseModal";
import { useHostName } from "shared/hooks/useHostName";
import tw from "twin.macro";
import { Paths } from "utils/routes";

const Section = tw.div`bg-blossom rounded-lg p-3 flex flex-col items-start`;

const SectionTitle = tw.h3`font-base text-sm leading-[14px] tracking-[.7px] mt-2`;

const SectionText = tw.p`font-base font-light text-[8px] leading-[14px] mt-1 text-left`;

const Label = tw.p`inline-block bg-gradient-theme-to-l rounded p-1.5 font-base text-[8px] leading-[8px] text-white`;

export const AuthModal = () => {
  const { host } = useHostName();

  const handleClickButton = () => {
    signIn("line", {
      callbackUrl: `${host}${Paths.callbacks.line.default().pathname}`,
    });
  };

  return (
    <BaseModal
      title="新規登録・ログイン"
      subTitle="鑑定に進むには新規登録もしくはログインが必要です"
    >
      <Section>
        <Label>MIRORおすすめポイント①</Label>
        <SectionTitle>会員登録はもちろん無料💰</SectionTitle>
        <SectionText>
          無駄な月額費用や不明な料金は一切かからないので安心して使える!
        </SectionText>
      </Section>
      <Section tw="mt-2">
        <Label>MIRORおすすめポイント②</Label>
        <SectionTitle>無駄な個人情報は登録不要⚠️</SectionTitle>
        <SectionText>
          名前もニックネームでOK!住所や本名など無駄な情報は要りません!
        </SectionText>
      </Section>
      <Section tw="mt-2">
        <Label>MIRORおすすめポイント③</Label>
        <SectionTitle>LINEで簡単、10秒で登録完了📱</SectionTitle>
        <SectionText>
          LINE通知で便利にご利用いただけます!もちろんブロックも可能!
        </SectionText>
      </Section>
      <PrivacyPolicy postfix="に同意して" tw="mt-3" />
      <Button
        tw="w-full bg-gradient-theme-to-l mt-3"
        onClick={handleClickButton}
      >
        <Image
          src={`${process.env.NEXT_PUBLIC_CDN_V2}/line_icon.png`}
          width={28}
          height={28}
          layout="fixed"
          tw="mr-2"
        />
        LINEで無料会員登録
      </Button>
      <Link href="/users/sign_in">
        <a>
          <div tw="mt-2 font-base text-2xs leading-6">
            その他登録方法・ログインは<span tw="text-theme">こちら</span>
          </div>
        </a>
      </Link>
    </BaseModal>
  );
};
